import { useWatch } from 'react-hook-form';
import { PAYMENT_TERMS } from '@vy/types';
import { VySwitchField } from '../../../../../../design-system-adapters/forms';
import { useChargeContext } from '../../charge-context';
import { useIsPayInAdvanceOnTierCrossVisible } from '../../../../../../hooks/use-is-pay-in-advance-on-tier-cross-visible';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

export const PayInAdvanceOnTierCrossSwitch: React.FC = () => {
  const { itemIndex: productIndex } = useChargeContext();
  const isVisible = useIsPayInAdvanceOnTierCrossVisible();
  const paymentTerm = useWatch({ name: `usageProducts.${productIndex}.paymentTerm` as const });

  if (!isVisible || paymentTerm !== PAYMENT_TERMS.Prepayment) {
    return null;
  }

  return (
    <VySwitchField<PlanInputForm>
      name={`usageProducts.${productIndex}.advancePayment.advancePaymentConfig.payInAdvanceOnTierCross`}
      title="Pay in advance on tier cross"
      description="Charge each tier upgrade in advance on the cross date, on its own invoice"
      data-field-span="full"
      data-vy="usage-charge-drawer-pay-in-advance-on-tier-cross-switch"
    />
  );
};
